import { render, staticRenderFns } from "./DisplayParametersTab.vue?vue&type=template&id=8d3298b2&"
import script from "./DisplayParametersTab.vue?vue&type=script&lang=js&"
export * from "./DisplayParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports